import React, { useState } from 'react'
import { Modal } from './Modal'
import { HeaderModal } from './Header'
import { Body } from './Body'
import { FooterModal } from './Footer'
import closeIcon from 'assets/images/close-icon.svg';
import modalBgShade from "../../../assets/images/bg-modal-shade.svg";
import allImgPaths from "assets/images";
import { InputTextField } from 'components/InputField'

const FeteConfirmationModal = ({ headerText, bodyText, mainText = null, setShowDeleteModal, confirmDelete, eventInfo, level, levelOneConfirm }: any) => {
    const [feteName, setFeteName] = useState('')
    const [isBtnDisabled, setIsBtnDisabled] = useState(true)

    const handleFeteNameChange = (e: any) => {
        const text = e.target.value;
        setFeteName(text)
        setIsBtnDisabled(text !== `Delete ${eventInfo.name}`)
    }

    const handleDelete = () => {
        setIsBtnDisabled(true)
        confirmDelete()
    }

    const handleOnPaste = (e: any) => {
        e.preventDefault()
    }

    return (
        <>
            <Modal className={"modal-wrapper max-w-[400px]"} isShow={setShowDeleteModal}>
                <div>

                    {/* Modal bg Shade */}
                    <img className="absolute top-0.5 left-0 object-contain -z-10" src={modalBgShade} alt="shade" />

                    <HeaderModal title={"test"} isShowHeader={true} className="modal-header pt-5 px-6">
                        <img className="cursor-pointer w-12 h-12 mb-3.5" src={allImgPaths.deleteIcon5} alt="remove" />
                        <div className="flex items-center justify-between pb-3">
                            <h2 className="text-lg text-[#101828] font-interSemiBold leading-none pb-1.5">{headerText}</h2>
                            <img
                                className="modal-close modal-toggle cursor-pointer hover:bg-[#f2f4f7] rounded w-5 p-1 -mt-[120px]"
                                id="modal-toggle"
                                src={closeIcon}
                                onClick={() => { setShowDeleteModal(false) }}
                                alt="close icon"
                            />
                        </div>
                        {
                            level == 1 &&
                            <>
                                {bodyText &&
                                    <p className='text-[#101828] pb-4'>{bodyText}</p>
                                }
                                <p className='text-[#101828]'>
                                    {
                                        mainText ? mainText : 'Are you sure you want to delete?'
                                    }
                                </p>
                            </>
                        }
                        {
                            level == 2 &&
                            <div className='text-[#101828] mt-2'>
                                <p>Please type the text in the box below:</p>
                                <p className='mt-3 font-interBold'>{`"Delete ${eventInfo.name}"`}</p>
                                <p className='mt-3'>
                                    <InputTextField
                                        name='fetename'
                                        value={feteName}
                                        onChange={handleFeteNameChange}
                                        placeholder='Enter fete name'
                                        onPaste={handleOnPaste}
                                    />
                                </p>
                            </div>
                        }

                    </HeaderModal>
                    <Body title="" isShowBody={true} className="modal-body px-3 pt-1">
                        <div className="modal-select-box fete-settings-modals">
                        </div>
                    </Body>

                    <FooterModal title="" isShowFooter={true} className="modal-footer pt-7 px-6 pb-6">
                        {
                            level == 1 &&
                            <div className="flex items-center gap-x-3 justify-end">
                                <button
                                    onClick={() => { setShowDeleteModal(false) }}
                                    className={`!text-base text-black border hover:border-[#1E0AF5] font-interSemiBold rounded-lg px-3.5 py-2.5 w-40`}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={levelOneConfirm}
                                    className={`!text-base text-white bg-[#D92D20] hover:bg-[#B42318] font-interSemiBold rounded-lg px-3.5 py-2.5 w-40`}
                                >
                                    Yes
                                </button>
                            </div>
                        }
                        {
                            level == 2 &&
                            <div className="flex items-center gap-x-3 justify-center">
                                <button
                                    onClick={handleDelete}
                                    className={`!text-base text-white bg-[#D92D20] hover:bg-[#B42318] font-interSemiBold rounded-lg px-3.5 py-2.5 flex-1 ${isBtnDisabled ? 'button-disabled' : ''} `}
                                    disabled={isBtnDisabled}
                                >
                                    Yes, Delete
                                </button>
                            </div>
                        }
                    </FooterModal>
                </div>

            </Modal>
        </>
    )
}

export default FeteConfirmationModal;
